import styled, { css } from "styled-components";

import { Grid, Container } from "@material-ui/core";

import Chip from "../../../../components/basics/Chip";
import { Body } from "../../../../patterns/modals/styles/SearchDialog";

const primary = (props) => props.theme.palette.primary;
const secondary = (props) => props.theme.palette.secondary;
const lightgreen = (props) => props.theme.palette.lightgreen;
const montserrat = (props) => props.theme.fonts.montserrat;
const mulish = (props) => props.theme.fonts.mulish;
const opensans = (props) => props.theme.fonts.opensans;

export const ChipTitleStyled = styled(Chip)`
  width: 100%;
`;

export const DivStyledIcons = styled.div`
  height: 50% !important;
`;

export const DivBtn = styled(Grid)`
  height: 88%;

  span {
    font-size: 0.65rem !important;
  }
`;

export const DivBox = styled(Grid)`
  label {
    padding: 8px 0px;
  }
`;

export const Header = styled.div`
  width: 100%;

  .MuiChip-root {
    width: 100%;
    font-size: 1rem;
    margin: 0;
  }
`;

export const StyledDialog = styled.div`
  .MuiDialogContent-root {
    padding: 0px 24px;
  }

  Button {
    span {
      font-family: ${mulish};
      font-weight: bolder;
      font-size: 0.975rem;
    }
  }

  ${Header} {
    .MuiChip-root {
      width: 100%;
      padding: 10px;
      margin: 0;

      .MuiChip-label {
        font-family: ${mulish};
        font-weight: bolder;
        font-size: 1rem;
      }
    }
  }

  ${Body} {
    ${Header} {
      margin-top: 10px;
    }

    Table {
      Thead {
        background-color: ${secondary};
        box-shadow: 3px 3px 3px ${(props) => props.theme.palette.darkgrey};
        tr {
          .Mui-checked {
            color: ${primary};
          }
          th {
            span {
              font-family: ${montserrat}, sans-serif !important;
            }
          }
        }
      }
      Tbody {
        td {
          font-family: ${opensans};
          .Mui-checked {
            color: ${primary};
          }
        }
        .Mui-selected {
          background-color: ${lightgreen};
          &:hover {
            background-color: ${lightgreen};
          }
          border: none;
        }
      }
    }
  }
`;

export const PainelContainer = styled(Container)`
  margin-top: 15vh;
`;

export const HeaderAccordion = styled.div`
  width: 100%;

  .MuiChip-root {
    cursor: pointer;
    padding: 20px;
    width: 100%;
    margin: 0;
    span {
      font-weight: bolder;
      font-family: ${mulish};
      font-size: 1.2rem;
    }
  }
`;

export const Margin = styled.div`
  ${(props) =>
    props.margin &&
    css`
      margin-top: ${(props) => props.margin.replace(/( )+/g, "px ")}px;
    `};

  ${(props) =>
    props.top &&
    css`
      margin-top: ${(props) => props.top}px;
    `};

  ${(props) =>
    props.left &&
    css`
      margin-left: ${(props) => props.left}px;
    `};

  ${(props) =>
    props.top &&
    css`
      margin-bottom: ${(props) => props.bottom}px;
    `};

  ${(props) =>
    props.right &&
    css`
      margin-right: ${(props) => props.right}px;
    `};
`;

export const FontButton = styled.div`
  width: 100%;
  Button {
    span {
      margin: 2.5px;
      font-family: ${opensans};
      font-size: 0.875rem;
    }
    height: 100%;
    .MuiIcon-root {
      font-family: "Material Icons" !important;
    }
  }
`;

export const HeaderModal = styled.div`
  .MuiDialogTitle-root {
    padding: 0px;
    .MuiTypography-h6 {
      line-height: unset;
    }
  }

  .MuiChip-root {
    margin: 0;
    padding: 10px;
    border-radius: 0px;
    width: 100%;

    .MuiGrid-root {
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        cursor: pointer;
      }
    }

    .MuiChip-label {
      width: 100%;
      align-items: center;
      justify-content: center;
      display: flex !important;
      font-family: ${montserrat}, sans-serif;
      font-size: 0.975rem;
    }
  }
`;

export const ModalCancelamento = styled.div`
  ${Body} {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`;

export const BtnNewAria = styled.div`
  height: 5vh;
  Button {
    height: 100%;
  }
  margin-bottom: 20px;
`;
